import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Prevent the browser from auto-restoring scroll position
// when navigating forward/backward in the SPA history stack.
if (typeof window !== 'undefined' && 'scrollRestoration' in window.history) {
  window.history.scrollRestoration = 'manual';
}

export const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Immediate reset
    window.scrollTo(0, 0);
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;

    // Also reset after the first paint to handle React 18 concurrent rendering
    // where effects can fire before the new page has replaced the old one.
    const raf = requestAnimationFrame(() => {
      window.scrollTo(0, 0);
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
    });

    return () => cancelAnimationFrame(raf);
  }, [pathname]);

  return null;
};
